import React, {createContext} from "react"
import {initialRegion, listRegion, RegionAction} from "@/providers/choose-region/reducer";
export interface IChooseRegionContext {
  regionSelected: string,
  listRegion: IRegionItem[]
  dispatch: React.Dispatch<RegionAction>
}
export interface IRegionItem {
  name: string,
  value: string,
  disabled?: boolean
}
const ChooseRegionContext = createContext<IChooseRegionContext>({
  regionSelected: initialRegion,
  listRegion: listRegion,
  dispatch: () => null
})

export default ChooseRegionContext
